export default "__VITE_PUBLIC_ASSET__20b17289__"